/**
 * `ConnectionModal` (`PlayChess/components/ConnectionModal`) behind its own
 * `React.lazy` boundary. A static import of an old `PlayChess/` component
 * from inside `overlay/` trips the eager-import guard
 * (`__tests__/eagerGraph.test.ts`); kept in its own module for the same
 * reason `pages/home/variants/classic/lazyRows.tsx` is — jest's transform
 * leaves `import()` alone, so a lazy boundary cannot be rendered under
 * react-test-renderer (segfault). `View.test.tsx` mocks THIS module to the
 * eager component instead of exercising the boundary for real.
 */
import React from 'react';

export default React.lazy(
  () => import('@/Screens/PlayChess/components/ConnectionModal'),
);
